// Vite's import.meta.glob() is the equivalent of Webpack's require.context()
// { eager: true } loads all modules synchronously at build time
const enModules = import.meta.glob('./en/*.json', { eager: true });
const frModules = import.meta.glob('./fr/*.json', { eager: true });

const importAllTranslations = (modules) => {
    const translations = {};
    for (const path in modules) {
        Object.assign(translations, modules[path].default || modules[path]);
    }
    return translations;
};

// Import base translations
export const enMessages = importAllTranslations(enModules);
export const frMessages = importAllTranslations(frModules);

// Check if clientSpecific messages directory exists
let clientSpecificEnModules = {};
let clientSpecificFrModules = {};
try {
    clientSpecificEnModules = import.meta.glob('../clientSpecific/messages/en/*.json', { eager: true });
    clientSpecificFrModules = import.meta.glob('../clientSpecific/messages/fr/*.json', { eager: true });
} catch (_e) {
    // If the directory doesn't exist or is empty, modules will be empty objects
}

// Import client-specific translations if available and merge with base translations
if (Object.keys(clientSpecificEnModules).length > 0) {
    const clientSpecificEnMessages = importAllTranslations(clientSpecificEnModules);

    // Log info about added keys (helpful for debugging)
    if (import.meta.env.DEV) {
        const newKeys = Object.keys(clientSpecificEnMessages).filter((key) => !Object.hasOwn(enMessages, key));
        if (newKeys.length > 0) {
            console.info(
                `[i18n] Client-specific translations adding ${newKeys.length} new English keys not in base template`,
            );
        }
    }

    // Merge client-specific translations (override existing keys and add new ones)
    Object.assign(enMessages, clientSpecificEnMessages);
}

if (Object.keys(clientSpecificFrModules).length > 0) {
    const clientSpecificFrMessages = importAllTranslations(clientSpecificFrModules);

    // Log info about added keys (helpful for debugging)
    if (import.meta.env.DEV) {
        const newKeys = Object.keys(clientSpecificFrMessages).filter((key) => !Object.hasOwn(frMessages, key));
        if (newKeys.length > 0) {
            console.info(
                `[i18n] Client-specific translations adding ${newKeys.length} new French keys not in base template`,
            );
        }
    }

    // Merge client-specific translations (override existing keys and add new ones)
    Object.assign(frMessages, clientSpecificFrMessages);
}

export default {
    en: enMessages,
    fr: frMessages,
};
